var React = require('react');

function GreenCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1601","data-name":"Path 1601","d":"M467,19.041l4.931,6.31,9.981-12.707","transform":"translate(-464.193 -9.836)","fill":"none","stroke":"#41b120","strokeLinecap":"round","strokeWidth":"4"}));
}

GreenCheckmark.defaultProps = {"width":"20.527","height":"18.758","viewBox":"0 0 20.527 18.758"};

module.exports = GreenCheckmark;

GreenCheckmark.default = GreenCheckmark;
